import React from 'react'
import {Grid, Header, Icon, Segment,} from 'semantic-ui-react'
import {TitleComponent} from "../components/Utils/TitleComponent";
import landing from '../assets/image/09.png';
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class Home extends React.PureComponent {
    render() {
        return <React.Fragment>
            <TitleComponent title="gqlX" />
            <Segment style={{ padding: '65wpx' }} vertical>
                <Grid container stackable verticalAlign='middle'>
                    <Grid.Row>
                        <Grid.Column width={4}>
                            <Header style={{ color: 'white', fontSize: '5em' }}>
                                gqlX
                            </Header>
                            <p color={"white"}  style={{ color: 'white', fontSize: '1.33em' }}>
                                the future of music, tokenized.

                            </p>
                        </Grid.Column>
                        <Grid.Column floated='right' width={10}>
                            <img src={landing}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column textAlign='center'>
                            <a href={"https://twitter.com/GqlxMusic"} target="_blank">
                                <Icon name='twitter' size='big' />
                            </a>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>

        </React.Fragment>;
    }
}

export default Home
